/*
 * jQuery Navgoco Menus Plugin v0.2.1 (2014-04-11)
 * https://github.com/tefra/navgoco
 *
 * Copyright (c) 2014 Chris T (@tefra)
 * BSD - https://github.com/tefra/navgoco/blob/master/LICENSE-BSD
 */
!(function (a) {
  'use strict';
  const b = function (b, c, d) {
    return (
      (this.el = b),
      (this.$el = a(b)),
      (this.options = c),
      (this.uuid = this.$el.attr('id') ? this.$el.attr('id') : d),
      (this.state = {}),
      this.init(),
      this
    );
  };

  (b.prototype = {
    init() {
      const b = this;
      b._load(),
        b.$el.find('ul').each(function (c) {
          const d = a(this);
          d.attr('data-index', c),
            b.options.save && b.state.hasOwnProperty(c)
              ? (d.parent().addClass(b.options.openClass), d.show())
              : d.parent().hasClass(b.options.openClass)
              ? (d.show(), (b.state[c] = 1))
              : d.hide();
        });
      const c = a('<span></span>').prepend(b.options.caretHtml);
      const d = b.$el.find('li > a');
      b._trigger(c, !1), b._trigger(d, !0), b.$el.find('li:has(ul) > a').prepend(c);
    },
    _trigger(b, c) {
      const d = this;
      b.on('click', function (b) {
        b.stopPropagation();
        let e = c ? a(this).next() : a(this).parent().next();
        let f = !1;
        if (c) {
          const g = a(this).attr('href');
          f = void 0 === g || g === '' || g === '#';
        }

        if (((e = e.length > 0 ? e : !1), d.options.onClickBefore.call(this, b, e), !c || (e && f))) {
          b.preventDefault(), d._toggle(e, e.is(':hidden')), d._save();
        } else if (d.options.accordion) {
          const h = (d.state = d._parents(a(this)));
          d.$el
            .find('ul')
            .filter(':visible')
            .each(function () {
              const b = a(this);
              const c = b.attr('data-index');
              h.hasOwnProperty(c) || d._toggle(b, !1);
            }),
            d._save();
        }

        d.options.onClickAfter.call(this, b, e);
      });
    },
    _toggle(b, c) {
      const d = this;
      const e = b.attr('data-index');
      const f = b.parent();
      if ((d.options.onToggleBefore.call(this, b, c), c)) {
        if ((f.addClass(d.options.openClass), b.slideDown(d.options.slide), (d.state[e] = 1), d.options.accordion)) {
          const g = (d.state = d._parents(b));
          (g[e] = d.state[e] = 1),
            d.$el
              .find('ul')
              .filter(':visible')
              .each(function () {
                const b = a(this);
                const c = b.attr('data-index');
                g.hasOwnProperty(c) || d._toggle(b, !1);
              });
        }
      } else {
        f.removeClass(d.options.openClass), b.slideUp(d.options.slide), (d.state[e] = 0);
      }

      d.options.onToggleAfter.call(this, b, c);
    },
    _parents(b, c) {
      const d = {};
      const e = b.parent();
      const f = e.parents('ul');
      return (
        f.each(function () {
          const b = a(this);
          const e = b.attr('data-index');
          return e ? void (d[e] = c ? b : 1) : !1;
        }),
        d
      );
    },
    _save() {
      if (this.options.save) {
        const b = {};
        for (const d in this.state) {
          this.state[d] === 1 && (b[d] = 1);
        }

        (c[this.uuid] = this.state = b), a.cookie(this.options.cookie.name, JSON.stringify(c), this.options.cookie);
      }
    },
    _load() {
      if (this.options.save) {
        if (c === null) {
          const b = a.cookie(this.options.cookie.name);
          c = b ? JSON.parse(b) : {};
        }

        this.state = c.hasOwnProperty(this.uuid) ? c[this.uuid] : {};
      }
    },
    toggle(b) {
      const c = this;
      let d = arguments.length;
      if (d <= 1) {
        c.$el.find('ul').each(function () {
          const d = a(this);
          c._toggle(d, b);
        });
      } else {
        let e;
        const f = {};
        const g = Array.prototype.slice.call(arguments, 1);
        d--;
        for (let h = 0; d > h; h++) {
          e = g[h];
          const i = c.$el.find('ul[data-index="' + e + '"]').first();
          if (i && ((f[e] = i), b)) {
            const j = c._parents(i, !0);
            for (const k in j) {
              f.hasOwnProperty(k) || (f[k] = j[k]);
            }
          }
        }

        for (e in f) {
          c._toggle(f[e], b);
        }
      }

      c._save();
    },
    destroy() {
      a.removeData(this.$el),
        this.$el.find('li:has(ul) > a').off('click'),
        this.$el.find('li:has(ul) > a > span').off('click');
    }
  }),
    (a.fn.navgoco = function (c) {
      if (typeof c === 'string' && c.charAt(0) !== '_' && c !== 'init') {
        var d = !0;
        var e = Array.prototype.slice.call(arguments, 1);
      } else {
        (c = a.extend({}, a.fn.navgoco.defaults, c || {})), a.cookie || (c.save = !1);
      }

      return this.each(function (f) {
        const g = a(this);
        let h = g.data('navgoco');
        h || ((h = new b(this, d ? a.fn.navgoco.defaults : c, f)), g.data('navgoco', h)), d && h[c].apply(h, e);
      });
    });
  var c = null;
  a.fn.navgoco.defaults = {
    caretHtml: '',
    accordion: !1,
    openClass: 'open',
    save: !0,
    cookie: { name: 'navgoco', expires: !1, path: '/' },
    slide: { duration: 400, easing: 'swing' },
    onClickBefore: a.noop,
    onClickAfter: a.noop,
    onToggleBefore: a.noop,
    onToggleAfter: a.noop
  };
})(jQuery);
